import React from 'react';

import { Text } from 'Components/Base';

import ConnectingIllustration from './ConnectingIllustration';

const LoadingContent = () => {
  return (
    <>
      <ConnectingIllustration />
      <Text
        mt={6}
        textAlign={'center'}
        fontFamily={"'IBM Plex Sans Thai Looped', Anuphan, sans-serif"}
        textStyle="heading5"
        color={'eggSpace.gray.900'}
      >
        {'ระบบกำลังเชื่อมต่อ'}
      </Text>
      <Text
        mt={2}
        textAlign={'center'}
        fontFamily={"'IBM Plex Sans Thai Looped', Anuphan, sans-serif"}
        textStyle="body2"
        color={'eggSpace.gray.600'}
      >
        {'กรุณารอสักครู่'}
      </Text>
    </>
  );
};

export default LoadingContent;
